/* tslint:disable */
/* eslint-disable */
/**
 * Y-Sports backend-next Management API
 * Composed management-facing contract for `backend-next`. This spec is an aggregation layer over module-scoped contracts and should reference canonical module definitions instead of copying them. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Player } from './Player';
import {
    PlayerFromJSON,
    PlayerFromJSONTyped,
    PlayerToJSON,
    PlayerToJSONTyped,
} from './Player';
import type { Person } from './Person';
import {
    PersonFromJSON,
    PersonFromJSONTyped,
    PersonToJSON,
    PersonToJSONTyped,
} from './Person';

/**
 * 
 * @export
 * @interface TournamentTeamRegistrationRequest
 */
export interface TournamentTeamRegistrationRequest {
    /**
     * Allows birth years outside category limits. The registrant accepts responsibility for clearing participation with organizers and obtaining parental approval for minors. Missing birth years and player-count limits are still validated.
     * @type {boolean}
     * @memberof TournamentTeamRegistrationRequest
     */
    ageCheckOverride?: boolean;
    /**
     * 
     * @type {string}
     * @memberof TournamentTeamRegistrationRequest
     */
    existingTeamId?: string;
    /**
     * 
     * @type {string}
     * @memberof TournamentTeamRegistrationRequest
     */
    teamName: string;
    /**
     * 
     * @type {string}
     * @memberof TournamentTeamRegistrationRequest
     */
    clubName?: string;
    /**
     * 
     * @type {string}
     * @memberof TournamentTeamRegistrationRequest
     */
    country?: string;
    /**
     * 
     * @type {string}
     * @memberof TournamentTeamRegistrationRequest
     */
    state?: string;
    /**
     * 
     * @type {string}
     * @memberof TournamentTeamRegistrationRequest
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof TournamentTeamRegistrationRequest
     */
    category: string;
    /**
     * 
     * @type {string}
     * @memberof TournamentTeamRegistrationRequest
     */
    gender?: string;
    /**
     * 
     * @type {string}
     * @memberof TournamentTeamRegistrationRequest
     */
    primaryColor?: string;
    /**
     * 
     * @type {string}
     * @memberof TournamentTeamRegistrationRequest
     */
    homeColor?: string;
    /**
     * 
     * @type {string}
     * @memberof TournamentTeamRegistrationRequest
     */
    awayColor?: string;
    /**
     * 
     * @type {string}
     * @memberof TournamentTeamRegistrationRequest
     */
    goalkeeperColor?: string;
    /**
     * 
     * @type {Array<Player>}
     * @memberof TournamentTeamRegistrationRequest
     */
    players?: Array<Player>;
    /**
     * 
     * @type {Array<Person>}
     * @memberof TournamentTeamRegistrationRequest
     */
    officials?: Array<Person>;
    /**
     * 
     * @type {Person}
     * @memberof TournamentTeamRegistrationRequest
     */
    creator?: Person;
    /**
     * 
     * @type {string}
     * @memberof TournamentTeamRegistrationRequest
     */
    templateId?: string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof TournamentTeamRegistrationRequest
     */
    customFields?: { [key: string]: any; };
}

/**
 * Check if a given object implements the TournamentTeamRegistrationRequest interface.
 */
export function instanceOfTournamentTeamRegistrationRequest(value: object): value is TournamentTeamRegistrationRequest {
    if (!('teamName' in value) || value['teamName'] === undefined) return false;
    if (!('category' in value) || value['category'] === undefined) return false;
    return true;
}

export function TournamentTeamRegistrationRequestFromJSON(json: any): TournamentTeamRegistrationRequest {
    return TournamentTeamRegistrationRequestFromJSONTyped(json, false);
}

export function TournamentTeamRegistrationRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): TournamentTeamRegistrationRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'ageCheckOverride': json['ageCheckOverride'] == null ? undefined : json['ageCheckOverride'],
        'existingTeamId': json['existingTeamId'] == null ? undefined : json['existingTeamId'],
        'teamName': json['teamName'],
        'clubName': json['clubName'] == null ? undefined : json['clubName'],
        'country': json['country'] == null ? undefined : json['country'],
        'state': json['state'] == null ? undefined : json['state'],
        'city': json['city'] == null ? undefined : json['city'],
        'category': json['category'],
        'gender': json['gender'] == null ? undefined : json['gender'],
        'primaryColor': json['primaryColor'] == null ? undefined : json['primaryColor'],
        'homeColor': json['homeColor'] == null ? undefined : json['homeColor'],
        'awayColor': json['awayColor'] == null ? undefined : json['awayColor'],
        'goalkeeperColor': json['goalkeeperColor'] == null ? undefined : json['goalkeeperColor'],
        'players': json['players'] == null ? undefined : ((json['players'] as Array<any>).map(PlayerFromJSON)),
        'officials': json['officials'] == null ? undefined : ((json['officials'] as Array<any>).map(PersonFromJSON)),
        'creator': json['creator'] == null ? undefined : PersonFromJSON(json['creator']),
        'templateId': json['templateId'] == null ? undefined : json['templateId'],
        'customFields': json['customFields'] == null ? undefined : json['customFields'],
    };
}

export function TournamentTeamRegistrationRequestToJSON(json: any): TournamentTeamRegistrationRequest {
    return TournamentTeamRegistrationRequestToJSONTyped(json, false);
}

export function TournamentTeamRegistrationRequestToJSONTyped(value?: TournamentTeamRegistrationRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'ageCheckOverride': value['ageCheckOverride'],
        'existingTeamId': value['existingTeamId'],
        'teamName': value['teamName'],
        'clubName': value['clubName'],
        'country': value['country'],
        'state': value['state'],
        'city': value['city'],
        'category': value['category'],
        'gender': value['gender'],
        'primaryColor': value['primaryColor'],
        'homeColor': value['homeColor'],
        'awayColor': value['awayColor'],
        'goalkeeperColor': value['goalkeeperColor'],
        'players': value['players'] == null ? undefined : ((value['players'] as Array<any>).map(PlayerToJSON)),
        'officials': value['officials'] == null ? undefined : ((value['officials'] as Array<any>).map(PersonToJSON)),
        'creator': PersonToJSON(value['creator']),
        'templateId': value['templateId'],
        'customFields': value['customFields'],
    };
}

